<template>
  <div class="transaction-law">
    <div class="container">
      <div class="header-section">
        <img src="/img/logo.png" alt="Guuu Eats" class="logo">
        <h1 class="page-title">特定商取引法に基づく表記</h1>
      </div>

      <div class="content-section">
        <div class="law-item">
          <h2 class="law-label">運用事業者名</h2>
          <p class="law-value">株式会社ｃｉｃａｃ</p>
        </div>

        <div class="law-item">
          <h2 class="law-label">運営責任者</h2>
          <p class="law-value">代表取締役 今氏一路</p>
        </div>

        <div class="law-item">
          <h2 class="law-label">所在地</h2>
          <p class="law-value">東京都渋谷区西原2丁目26-5</p>
        </div>

        <div class="law-item">
          <h2 class="law-label">電話番号</h2>
          <p class="law-value">0277-66-9498</p>
        </div>

        <div class="law-item">
          <h2 class="law-label">メールアドレス</h2>
          <p class="law-value">service@guuu.app</p>
        </div>

        <div class="law-item">
          <h2 class="law-label">サービス内容</h2>
          <p class="law-value">
            本サービスは、個人利用者がスマートフォンやWebからお弁当を簡単に注文し、キャッシュレス決済によって支払いを完了し、指定場所で受け取れるデリバリーサービスです。利用者は豊富なメニューから好みに合わせて選択でき、注文状況をリアルタイムで確認できる利便性を備えています。<br>
          </p>
        </div>

        <div class="law-item">
          <h2 class="law-label">販売価格</h2>
          <p class="law-value">各商品（お弁当）の注文画面に表示される金額（税込）</p>
        </div>

        <div class="law-item">
          <h2 class="law-label">お支払い方法</h2>
          <p class="law-value">
            ・クレジットカード決済<br>
            <!-- ・PayPay -->
          </p>
        </div>

        <div class="law-item">
          <h2 class="law-label">お支払い時期</h2>
          <p class="law-value">
            クレジットカード決済：注文確定時
            <!-- その他決済方法：各決済サービスの規約に準ずる -->
          </p>
        </div>

        <div class="law-item">
          <h2 class="law-label">追加手数料</h2>
          <p class="law-value">配送料・サービス手数料込みの表記のため、商品代金以外の必要料金は特にありません<br>また表示価格は税込です</p>
        </div>

        <div class="law-item">
          <h2 class="law-label">商品の引き渡し時期</h2>
          <p class="law-value">ご注文確定後、指定された配達希望日に合わせ、提携の配達先へお届けいたします<br>準備の都合上、即時でのご注文は承ることができません</p>
        </div>

        <div class="law-item">
          <h2 class="law-label">返品・交換について</h2>
          <p class="law-value">
            サービスの性質上、注文確定後のキャンセルは原則不可とし、お客様都合による返品・交換はお受けできません。<br>
            ただし、商品に不備があった場合は、商品到着後速やかにご連絡ください。<br>
            当社の責に帰すべき事由がある場合はこの限りではありません。
          </p>
        </div>
      </div>
    </div>
    <SectionFooter />
  </div>
</template>

<script>
import SectionFooter from '@/components/sections/SectionFooter.vue';

export default {
  name: 'TransactionLaw',
  components: {
    SectionFooter,
  },
  metaInfo: {
    title: '特定商取引法に基づく表記',
  },
};
</script>

<style scoped>
.transaction-law {
  min-height: 100vh;
  background: #f8f9fa;
}

.container {
  max-width: 800px;
  margin: 0 auto 60px;
  padding: 40px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.transaction-law > .container {
  margin-top: 40px;
}

.header-section {
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 2px solid #e9ecef;
}

.logo {
  width: 120px;
  height: auto;
  margin-bottom: 20px;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  color: #2c3e50;
  margin: 0;
  letter-spacing: 0.05em;
}

.content-section {
  padding: 0 20px;
}

.law-item {
  margin-bottom: 35px;
  padding-bottom: 25px;
  border-bottom: 1px solid #e9ecef;
}

.law-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.law-label {
  font-size: 16px;
  font-weight: bold;
  color: #495057;
  margin-bottom: 12px;
  position: relative;
  padding-left: 20px;
}

.law-label::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background: #c30d23;
  border-radius: 2px;
}

.law-value {
  font-size: 15px;
  color: #6c757d;
  line-height: 1.8;
  margin: 0;
  padding-left: 20px;
}

@media (max-width: 768px) {
  .transaction-law > .container {
    margin-top: 20px;
  }

  .container {
    padding: 30px 20px;
    border-radius: 0;
  }

  .header-section {
    margin-bottom: 30px;
  }

  .logo {
    width: 100px;
  }

  .page-title {
    font-size: 22px;
  }

  .content-section {
    padding: 0;
  }

  .law-item {
    margin-bottom: 25px;
    padding-bottom: 20px;
  }

  .law-label {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .law-value {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 25px 15px;
  }

  .page-title {
    font-size: 20px;
  }

  .law-label {
    font-size: 14px;
  }

  .law-value {
    font-size: 13px;
  }
}
</style>
